import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Notice } from 'telia-front-react';
import InternetCalculatorStore from '../../../stores/InternetCalculatorStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface DealerWithoutCustomerErrorProps {
  calculatorKey: string;
  internetCalculatorStore?: InternetCalculatorStore;
}

function DealerWithoutCustomerError(props: DealerWithoutCustomerErrorProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;
  const { calculatorKey, internetCalculatorStore } = props;

  if (!internetCalculatorStore.isDealerWithoutCustomer(calculatorKey)) {
    return null;
  }

  return <Notice type="error">{translate('internetAndTvCalculator.dealerWithoutCustomerError')}</Notice>;
}

export default inject('internetCalculatorStore')(observer(DealerWithoutCustomerError));
